/**
 * Admin Event Kiosk Page
 *
 * Dedicated page for the in-person lead-capture (Event Kiosk) controls.
 * Was previously embedded in the Admin Control Panel; promoted to its own page
 * and exposed via the Admin → Management dropdown.
 */
import React from "react";
import AdminNav from "../components/AdminNav";
import AdminTopMenuBar from "../components/AdminTopMenuBar";
import AdminMobileBottomNav from "../components/AdminMobileBottomNav";
import UniversalFooter from "../components/UniversalFooter";
import KioskLauncherCard from "../components/admin/control-panel/KioskLauncherCard";

const AdminKioskPage = () => {
  return (
    <div className="min-h-screen bg-slate-950" data-testid="admin-kiosk-page">
      <AdminNav />
      <AdminTopMenuBar />

      <main className="mx-auto max-w-3xl px-4 py-8 pb-24 md:pb-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white">Event Kiosk</h1>
          <p className="text-slate-400 mt-1">
            Start or resume an in-person lead-capture session and verify outbound email delivery.
          </p>
        </div>

        {/* Kiosk Launcher (same widget previously shown on Control Panel) */}
        <section data-testid="kiosk-launcher-section">
          <KioskLauncherCard />
        </section>
      </main>

      <AdminMobileBottomNav />
      <UniversalFooter />
    </div>
  );
};

export default AdminKioskPage;
